import ScheduleSessionForm from "../../forms/ScheduleSessionForm";
import "./book_slot.css";

export default function ScheduleSession() {
  return (
    <div className="schedule_session_container">
      <ScheduleSessionForm />
    </div>
  );
}
